import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@zlib/services/auth.service';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LocalStorageService } from '@zlib/services/localstorage.service';

@Injectable()
export class RoleGuard  {
    constructor(
        public auth: AuthService,
        public router: Router,
        private jwtHelper: JwtHelperService,
        private localStorageService: LocalStorageService
    ) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // this will be passed from the route config
        // on the data property
        const expectedRole: string[] = route.data.roles;
        const token = this.localStorageService.loadInfo('token');
        try {
            // decode the token to get its payload
            const tokenPayload = this.jwtHelper.decodeToken(token) as any;
            if (!this.auth.isAuthenticated()) {
                this.auth.logout();
                // this.router.navigate(['/auth/login']);
                return false;
            }
            if (!expectedRole.includes(tokenPayload.Role)) {
                this.router.navigate(['/error/not-permission'], { queryParams: { returnUrl: state.url } });
                return false;
            }
            return true;
        } catch (err) {
            this.router.navigate(['/error/not-permission'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}
